import { Bar } from 'vue-chartjs'

const test = {
  labels: ['January', 'February'],
  datasets: [
    {
      label: 'GitHub Commits',
      backgroundColor: '#f87979',
      data: [40, 20]
    }
  ]
}
export default {
  extends: Bar,
  data () {
    return {
      test: test
    }
  },
  computed: {},
  methods: {},
  mounted () {
    this.renderChart(test, {})
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/Charts/BarChart.js